import { React, Link,useState, useEffect, useRef, PageStyle, QUICK_ADD, getSession, REDIRECT} from '@/imports-files/components/quick-add';

function QuickAdd(props)
{
    const dropdownRef                 =    useRef(null);
    const [isActive, setIsActive]     =    useState(false);
    const [session, setSession ]      =    useState(props.session);
    const handleOtherDropdown         =    () => setIsActive(!isActive);
    const [isLoading, setLoading]     =    useState(true);
    const [readAccess, setReadAccees] =    useState(props.session?.role == 'SubAdministrator' ? true : false);
    function closeDropDown(setIsActive)
    {
       setTimeout(()=> setIsActive(false), 50)
    }

    useEffect(()=>{ 

      setLoading(false);
     
      const pageClickEvent = (e) => {
                                      // If the active element exists and is clicked outside of
                                      if (dropdownRef.current !== null && !dropdownRef.current.contains(e.target)) 
                                      {
                                        setIsActive(!isActive);
                                      }
                                    };

      if (isActive) 
      {
        window.addEventListener('click', pageClickEvent);
      }
    
      return () => {
        window.removeEventListener('click', pageClickEvent);
      }
      

  },[isActive])
  

  if(isLoading)
  {
    return ''
  }

    return (
              <>
                <div ref={dropdownRef} className={`${PageStyle.ClientCompany__FloatButtonAdd} ${readAccess ? 'disabled pointernone disabledborder' : ''}`} onClick={handleOtherDropdown}>+</div>
                <nav className={`quickadddropdown ${isActive && !readAccess ? 'active' : 'inactive'}`}>
                  <ul style={{marginBottom : "0px"}}>
                    <li className = {`mb10`} disabled={true} onClick = {() => {closeDropDown(setIsActive)}}><Link href = {REDIRECT.client.jobs.new}>Create a Job</Link></li>
                    <li className = {`mb10`}  onClick = {() => {closeDropDown(setIsActive)}}><Link href = {REDIRECT.client.candidates.add_candidate}>Add Candidate</Link></li>
                    { QUICK_ADD.allowed_roles_add_team.includes(session?.role) && !process.env.NEXT_PUBLIC_CHARLIE_HR && <li className={`mb10`} onClick={() => {closeDropDown(setIsActive)}}><Link href={REDIRECT.client.company.add_members}>Add Team</Link></li>}
                  </ul>
                </nav>
              </>
           )

}

export default QuickAdd;
